import {Button, Col, Row} from "react-bootstrap";
import Container from "react-bootstrap/Container";
import API from "../api/api"
import {useEffect, useState} from "react";
import {Link, useNavigate, useParams} from "react-router-dom";

function Profile() {
    const navigate = useNavigate();
    const params = useParams();
    const username = params.username;
    const loggedUsername = localStorage.getItem("username");
    const password = localStorage.getItem("password");
    const [user, setUser] = useState(false);
    const [gameActivity, setGameActivity] = useState(false);
    const [stripeManageLink, setStripeManageLink] = useState("");

    useEffect(() => {
        if (loggedUsername !== username) {
            return;
        }
        API.get("payments/stripe/manage-link", {
            headers: {
                username: loggedUsername,
                password: password
            }
        }).then(response => {
            setStripeManageLink(response.data);
        })


    }, []);

    useEffect(() => {
        if (loggedUsername === username) {
            API.get("users/get-by-username?fetch-username=" + username, {
                headers: {
                    username: loggedUsername,
                    password: password
                }
            }).then(response => {
                setUser(response.data);
            })
        } else {
            API.get("users/get-by-username/public?fetch-username=" + username).then(response => {
                setUser(response.data);
            })
        }

    }, []);

    useEffect(() => {
        API.get("users/get-user-game-data/all?fetch-username=" + username).then(response => {
            setGameActivity(response.data);
        })

    }, []);


    function handleDelete() {
        API.delete("users/delete-user?delete-username=" + username, {
            headers: {
                username: loggedUsername,
                password: password
            }
        }).then(response => {
            localStorage.removeItem("username");
            localStorage.removeItem("password");
            navigate("/");
            window.location.reload();
        }).catch(error => {
            console.log(error);
        })
    }

    const knownGameNameCorrections = {
        "brilliance": "Brilliance",
        "corridor": "Corridor",
        "driftfire showdown": "DriftFire Showdown"
    }

    function gameNameCorrection(gameName) {
        if (knownGameNameCorrections[gameName]) {
            return knownGameNameCorrections[gameName];
        }
        return gameName;
    }

    return (
        <div className="bg-gradient-dark text-white">

            <Container data-bs-theme="dark"
                       className="mt-5 pt-5 d-flex flex-column justify-content-centert align-items-center w-100">
                {!user &&
                    <div className="spinner-border" role="status">
                    </div>
                }
                {user && (
                    <>
                        <Row className="mb-5">
                            <Col>
                                <img src={user.profile_picture_url}
                                     alt="Profile Picture"
                                     height="100"
                                     width="100"
                                     className="d-inline-block align-top rounded-circle ratio-1x1"
                                />
                            </Col>
                            <Col>
                                <p className="display-3">{user.username}</p>
                            </Col>
                        </Row>

                        <div>
                            {(user.username === loggedUsername) && (
                                <>
                                    <p className="h4">Name: {user.firstname} {user.lastname}</p>
                                    <p>Email: {user.email}</p>
                                    <p>Birth Date: {user.birth_date ? user.birth_date.substring(0, 10) : "Unknown"}</p>
                                </>
                            )}

                            <p>Member since: {user.signup_date.substring(0, 10)}</p>
                        </div>
                        <Row>
                            {(user.username === loggedUsername) && (
                                <Button as={Col} className="m-5" onClick={(e) => {
                                    navigate("/users/" + username + "/edit")
                                }}>Edit</Button>
                            )}
                            {(stripeManageLink) && (
                                <Button as={Col} className="m-5" variant="primary" onClick={(e) => {
                                    window.open(stripeManageLink, "_blank").focus()
                                }}>Manage Subscriptions</Button>
                            )}
                            {(user.username === loggedUsername) && (
                                <Button as={Col} className="m-5 bg-danger border-0"
                                        onClick={handleDelete}>Delete</Button>
                            )}
                        </Row>
                        <h1 className="h1 m-2 mt-5">Activity</h1>
                        <Container data-bs-theme="dark">
                            {!gameActivity &&
                                <div className="spinner-border" role="status">
                                </div>
                            }
                            {gameActivity && gameActivity.map((game, i) => (
                                <Row key={i} className={"w-100 m-5 d-flex"}>
                                    <Link to={"/games/" + gameNameCorrection(game.game_name)}
                                          className="text-decoration-none d-flex justify-content-start text-white w-50">
                                        <img width={"150"} height={"150"} className="ratio-1x1 rounded-4 mx-3"
                                             src={'https://storage.googleapis.com/milky-way-trail-website-storage/game-content/' + game.game_name.replaceAll(" ", "-") + '-logo.png'}>

                                        </img>
                                        <div className="m-2 mx-5 d-flex flex-column justify-content-center">
                                            <h2>{gameNameCorrection(game.game_name)}</h2>
                                            <p className="m-2">Score: {game.score}</p>
                                            <p className="m-2">Wins: {game.wins}</p>
                                            <p className="m-2">Loses: {game.loses}</p>
                                        </div>
                                    </Link>
                                </Row>
                            ))}
                        </Container>
                    </>
                )}
            </Container>
        </div>
    );
}

export default Profile;